import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metiers-environnement',
  templateUrl: './metiers-environnement.component.html',
  styleUrls: ['./metiers-environnement.component.scss']
})
export class MetiersEnvironnementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
